import React from 'react';
import {useTranslation} from 'react-i18next';

import {Button, ButtonGroup} from '@veneer/core';

import useStyles from './styles';

const StepActions = ({
    back,
    next,
    nextDisabled,
    nextText,
    cancel,
    loading = false,
    finalStep = false,
}: {
    back?: () => void;
    next: () => void;
    nextDisabled?: boolean;
    nextText?: string;
    cancel: () => void;
    loading?: boolean;
    finalStep?: boolean;
}) => {
    const {t} = useTranslation(['StepActions']);
    const styles = useStyles();

    if (!nextText) {
        if (finalStep) {
            nextText = t('StepActions:confirm', 'Confirm and save');
        } else {
            nextText = t('StepActions:next', 'Next');
        }
    }

    return (
        <div className={styles.wrapper}>
            <ButtonGroup>
                <Button
                    appearance="ghost"
                    onClick={cancel}
                >
                    {t('StepActions:cancel', 'Cancel')}
                </Button>
            </ButtonGroup>

            <ButtonGroup className={styles.primaryActions}>
                {back && (
                    <Button
                        appearance="secondary"
                        onClick={back}
                    >
                        {t('StepActions:back', 'Back')}
                    </Button>
                )}
                <Button
                    loading={loading}
                    onClick={next}
                    disabled={nextDisabled}
                >
                    {nextText}
                </Button>
            </ButtonGroup>
        </div>
    );
};

export default StepActions;
